export default {
  settings: 'settings',
  about: 'about',
};
